import { useTranslation } from 'next-i18next';
import Head from 'next/head';
import { useRouter } from 'next/router';
import { withBasePath } from 'src/common/pathConvert';
import { headConfig } from 'src/utils/configs/head';

const titleList: any = headConfig;

export const ComHeader = ({ title }: any) => {
    return (
        <Head>
            <title>{title}</title>
            <meta name='description' content={title} />
            <link rel='icon' href={withBasePath('/favicon.ico')} />
        </Head>
    );
};
